// ConfirmedBooking.js
import React from 'react';
import '../../src/App.css';
function ConfirmedBooking() {
  return (
    <section id='conformation-body'>
      <p id='confirmation-info'>Booking Confirmed</p>
    </section>
  );
}

export default ConfirmedBooking;
